import { useTranslation } from 'gatsby-plugin-react-i18next'
import { useMemo } from 'react'

export const localize = (value: any, lang = 'en'): any => {
  if (Array.isArray(value)) {
    return value.map((v) => localize(v, lang))
  }

  if (typeof value === 'object' && value !== null) {
    if (/^locale[A-Z]/.test(value._type)) {
      return localize(value[lang], lang)
    }

    return Object.fromEntries(
      Object.entries(value).map(([key, val]) => {
        return [key, localize(val, lang)]
      })
    )
  }

  return value
}

export const useLocalize = (data: any) => {
  const { i18n } = useTranslation()

  return useMemo(() => {
    return localize(data, i18n.language)
  }, [i18n, data])
}
